<div class="search-container" matAutocompleteOrigin #origin="matAutocompleteOrigin">
  @if (!searchStore.searching()) {
    <div class="search-icon-container" [class.disabled]="!searchControl.value" gnxRtl>
      <img src="/assets/svg/analyze-tool.svg" class="search-icon" (click)="onSearch()" />
    </div>
  }
  @if (searchStore.searching()) {
    <gnx-dots-loader />
  }
  <input
    class="search-input"
    placeholder="{{ 'SEARCH_ANY_CASE' | i18n }}"
    [matAutocomplete]="casesAutocomplete"
    [matAutocompleteConnectedTo]="origin"
    [formControl]="searchControl"
    (keyup.esc)="onEscape()"
    (keydown.enter)="onSearch()"
  />
  @if ((searchStore.searchDone() && !searchStore.analysisResultSuggestions()) || searchStore.searchError()) {
    <div class="search-error">
      {{ searchStore.searchError() }}
    </div>
  }
</div>
<mat-autocomplete #casesAutocomplete="matAutocomplete" panelWidth="600px" class="cases-autocomplete">
  @for (analysis of searchStore.analysisResultSuggestions(); track analysis) {
    <mat-option
      class="search-option"
      [class.error]="!analysis.id"
      [value]="analysis.name"
      (onSelectionChange)="onSelect(analysis.id)"
    >
      @if (analysis.id) {
        <div>
          <div
            class="analysis-option-name"
            [innerHTML]="analysis.name | highlight: searchControl.value : 'green-highlight bold-highlight' | safeHtml"
          ></div>
          <div class="analysis-option-creation">Created on: {{ analysis.created_at | date }}</div>
        </div>
      }
      @if (!analysis.id) {
        <div class="analysis-option-error">
          <div class="analysis-option-error-title">No results found</div>
          <div>Try adjusting your search and check spelling</div>
        </div>
      }
    </mat-option>
  }
</mat-autocomplete>
